import MicroModal from 'micromodal';

let getModalId;

const DEFAULT_OPTIONS = {
  onShow: () => document.body.classList.add('u-overflowHidden'),
  onClose: () => {
    document.body.classList.remove('u-overflowHidden');
    if (getModalId === 'onboarding_intro_video') {
      // Hack attack: we need to dispose of this specific video when the user exits the modal
      const modal = document.getElementById(getModalId);
      modal.parentNode.removeChild(modal);
    }
  }
};

/**
 * Show a modal.
 * @param {String} modalId - The ID of the modal to show.
 * @param {Object} options - Options to customize the instance of MicroModal. For a list of available options,
 * see https://micromodal.now.sh/#configuration
 * @returns {undefined}
 */
const showModal = (modalId = '', options = {}) => {
  getModalId = modalId;
  MicroModal.show(getModalId, {
    ...DEFAULT_OPTIONS,
    ...options
  });
};

/**
 * Hide a modal.
 * @param {String} modalId - The ID of the modal to hide.
 * @returns {undefined}
 */
const hideModal = (modalId = '') => {
  MicroModal.close(modalId);
};

/**
 * Initialize a modal to be opened/closed via data attributes.
 * Set data-micromodal-trigger="modal-1" on an element, like a button or link,
 * on whose click you want to show the modal. The value of the attribute, in this case modal-1,
 * should correspond to the id of the modal you want to toggle.
 * @param {Object} options - Options to customize the instance of MicroModal. For a list of available options,
 * see https://micromodal.now.sh/#configuration
 * @returns {undefined}
 */
const initModal = (options = {}) => {
  MicroModal.init({
    ...DEFAULT_OPTIONS,
    ...options
  });
};

export { hideModal, initModal, showModal };
